import { render, staticRenderFns } from "./ClientAction.vue?vue&type=template&id=9c87aeb6&"
import script from "./ClientAction.vue?vue&type=script&lang=js&"
export * from "./ClientAction.vue?vue&type=script&lang=js&"
import style0 from "./ClientAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports